import { useSearchParams } from "react-router-dom";
import { Container, DialogContent } from "@mui/material";

//import constants
import { BREAKPOINT, WIDTH } from "../../../../constants/breakpoints.js";

//import general components
import BaseDialog from "../../../common/base-dialog/base-dialog.jsx";

//import view components
import SearchFormContent from "./search-form-content.jsx";
import DetailsHeader from "../../../common/details-header/details-header.jsx";
import { t } from "i18next";

function IntFlightSearchForm({ setRequestFlag, openSearchForm, setUid }) {
    //general variables
    const [searchParams, setSearchParams] = useSearchParams();
    const { isItinerary } = JSON.parse(sessionStorage.getItem("generalInformation")) || {};
    const intFlightInformation = JSON.parse(sessionStorage.getItem("intFlightInformation"));

    //handle close modal
    const handleClose = () => {
        if (isItinerary || searchParams.get("action") === "edit") {
            searchParams.delete("action");
            setSearchParams(searchParams);
        }
    };

    return (
        <>
            {WIDTH > BREAKPOINT ? (
                <>
                    {openSearchForm ? (
                        <Container maxWidth="xl">
                            <SearchFormContent setRequestFlag={setRequestFlag} setUid={setUid} intFlightRoute={false} />
                        </Container>
                    ) : (
                        <DetailsHeader type="flight" data={intFlightInformation} />
                    )}
                </>
            ) : (
                <BaseDialog title={t("edit")} open={openSearchForm} handleClose={handleClose} top="0" icon="close">
                    <DialogContent dividers={true}>
                        <SearchFormContent setRequestFlag={setRequestFlag} setUid={setUid} intFlightRoute={false} />
                    </DialogContent>
                </BaseDialog>
            )}
        </>
    );
}
export default IntFlightSearchForm;
